import apiClient from "./apiClient";

const lessonServices = {
  getLessons: (id) => {
    return apiClient.get(`/lessons/${id}`);
  },
  getLessonProject: (id, { type } = {}) => {
    const url = `/lesson-project/${id}`;
    const params = new URLSearchParams();

    if (type) {
      params.append("type", type);
    }

    const finalUrl = params.toString() ? `${url}?${params}` : url;

    return apiClient.get(finalUrl);
  },
  getStudentLessonProject: (lessonId) => {
    return apiClient.get(`/student-lesson-project/${lessonId}`);
  },
  getStudentLessonProjectDetails: (lessonId) => {
    return apiClient.get(`/lesson-level-project/${lessonId}`);
  },
  getVideo: (id, type = "lesson") => {
    return apiClient.get(`/lesson-video/${id}`, {
      params: { type },
    });
  },
  getLessonGames: (id) => {
    return apiClient.get(`/game/${id}`);
  },
  getLessonGameStage: (id) => {
    return apiClient.get(`/lesson-stage/${id}`);
  },
  submitGame: (id, payload) => {
    return apiClient.post(`/submit-game/${id}`, payload);
  },
  getIsRecapVideoViewed: (id) => {
    return apiClient.get(`/is-recap-viewed/${id}`);
  },
  addViewRecap: (id) => {
    return apiClient.get(`/view-recap/${id}`);
  },
  getLessonQuestions: (id) => {
    return apiClient.get(`/lesson-questions/${id}`);
  },
  getStudentLessonQuestions: (id) => {
    return apiClient.get(`/questions/${id}`);
  },
  startLesson: (id) => {
    return apiClient.get(`/start-lesson/${id}`);
  },
  finishLesson: (id) => {
    return apiClient.get(`/finish-lesson/${id}`);
  },
  takeQuestionsPoints: (id) => {
    return apiClient.get(`/take-questions-points/${id}`);
  },
  takeCodeLessonPoints: (id) => {
    return apiClient.get(`/take-code-lesson-points/${id}`);
  },
  takeWatchVideoPoints: (id) => {
    return apiClient.get(`/watch-video/${id}`);
  },
  checkAnswer: (questionID, answerID) => {
    return apiClient.get(`/question/check-answer/${questionID}/${answerID}`);
  },
  getLessonSteps: (id) => {
    return apiClient.get(`/lesson-steps/${id}`);
  },
  toggleLockLesson: (classroomID, lessonID) => {
    return apiClient.get(`/unlock-lesson/${classroomID}/${lessonID}`);
  },
  getChallenges: (lessonID) => {
    return apiClient.get(`/lesson-projects/${lessonID}`);
  },
};

export default lessonServices;
